import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentSession } from "@/hooks/useSession";
import { toast } from "react-toastify";

import Navbar from "./Navbar";

const MainLayout = () => {
  const navigate = useNavigate();
  const sessionStarted = localStorage.getItem("sessionStarted");

  // فحص حالة الجلسة
  const { data: sessionData, isLoading: isLoadingSession } =
    useCurrentSession();

  // فحص إذا كانت الجلسة منتهية أو غير موجودة
  useEffect(() => {
    // إذا انتهى التحميل ولم توجد جلسة نشطة وتم بدء جلسة محليًا → الذهاب إلى صفحة بدء الجلسة بدون تسجيل خروج
    if (!isLoadingSession && !sessionData && sessionStarted) {
      toast.error("لا توجد جلسة نشطة، ابدأ جلسة جديدة");
      navigate("/start-session");
      return;
    }

    // إذا كانت الجلسة موجودة لكنها منتهية وتم بدء جلسة محليًا → الذهاب إلى صفحة بدء الجلسة بدون تسجيل خروج
    if (sessionData && sessionData.ended_at && sessionStarted) {
      toast.error("انتهت الجلسة، ابدأ جلسة جديدة");
      navigate("/start-session");
      return;
    }
  }, [sessionData, isLoadingSession, navigate, sessionStarted]);

  // الاستماع لتغييرات localStorage من تبويب آخر (إغلاق الجلسة خارجيًا)
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === "sessionStarted" && e.newValue !== "true") {
        toast.error("انتهت الجلسة، ابدأ جلسة جديدة");
        navigate("/start-session");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [navigate]);

  return (
    <div className='min-h-screen bg-background flex flex-col' dir='rtl'>
      <main className='flex-1'>
        <div className='container mx-auto px-4 py-6 pb-24'>
          <Outlet />
        </div>
      </main>
      <Navbar />
    </div>
  );
};

export default MainLayout;
